/**
 * @fileoverview POST handler for the "/engagement/webhook_templates/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { engagementWebhookTemplatesIdCacheKeys } from "./constants";
import type {
  PostEngagementWebhookTemplatesIdProps,
  PostEngagementWebhookTemplatesIdResponse,
  WebhookTemplateUpsertError,
} from "./types";

export const postEngagementWebhookTemplatesId = reactQueryMutationAdapter(
  engagementWebhookTemplatesIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<WebhookTemplateUpsertError>()(
    (props: PostEngagementWebhookTemplatesIdProps): Promise<PostEngagementWebhookTemplatesIdResponse> => {
      return fetch(`/engagement/webhook_templates/${props.id}`, "POST", props, undefined, {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      });
    }
  )
);
